import { render, staticRenderFns } from "./AccessDigitalCard.vue?vue&type=template&id=82fd5f58&"
import script from "./AccessDigitalCard.vue?vue&type=script&lang=js&"
export * from "./AccessDigitalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports